import List from 'src/storage/list';
import moment from 'moment';
import adminModel from 'src/pages/admin/main/model';

class AllStatsDoctorsModel extends List {
  id = 'AllStatsDoctorsModel';
  defaultState = () => ({
    currency: this.getCurrency(),
    current: 'recent',
    pageIndex: 0,
    sortBy: {
      key: 'week_earnings',
      desc: true
    },
    startDate: moment().utc().startOf('isoWeek'),
    endDate: moment().endOf('day').utc()
  });
  refreshOnInit = false;
  refreshOnSubscribe = false;
  apiConfig = {
    refresh: {
      url: 'doctorStats/all',
      validation: {
        skip: 'skip',
        limit: 'limit',
        currency: 'currency'
      },
      cancellable: true
    },
    list: {
      url: 'doctorStats/all',
      validation: {
        skip: 'skip',
        limit: 'limit',
        currency: 'currency'
      },
      cancellable: true
    },
    search: {
      url: 'doctorStats/all',
      validation: {
        skip: 'skip',
        limit: 'limit',
        currency: 'currency'
      },
      cancellable: true
    },
    pay: {
      url: 'doctorStats/pay',
      validation: {
        accountId: 'userId',
        endDate: 'required',
        startDate: 'required'
      },
      cancellable: true
    },
    unpay: {
      url: 'doctorStats/unpay',
      validation: {
        accountId: 'userId',
        endDate: 'required',
        startDate: 'required'
      },
      cancellable: true
    }
  };

  _events = {
    profile: 'handleChangeProfileAndSwitchAccount',
    change_currency: 'handleChangeCurrency'
  };

  listParams() {
    let req = {
      skip: this.state.pageIndex * this.listLimit,
      limit: this.listLimit,
      sortBy: this.state.sortBy.key,
      sortDesc: !!this.state.sortBy.desc,
      accountType: 'doctor',
      currency: this.getCurrency()
    };
    let startDate = this.input('startDate');
    if (startDate) {
      req.startDate = parseInt(startDate.clone().startOf('day').utc().valueOf());
    }
    let endDate = this.input('endDate');
    if (endDate) {
      req.endDate = parseInt(endDate.clone().endOf('day').utc().valueOf());
    }
    let query = this.listInput('search');
    if (query.length > 0) {
      req.query = query;
    }
    return req;
  }

  getTotalData = (prefix, field) => {
    let items = this.items();
    let result = 0;
    items.forEach((item) => {
      if (item[prefix + '_' + field] > 0) result += item[prefix + '_' + field];
    });
    if (result.toString().split('.')[1]?.length > 2) result = result.toFixed(2);
    return result;
  };

  actions = (item, action) => {
    const req = { accountId: item.id };
    let startDate = this.input('startDate');
    if (startDate) {
      req.startDate = parseInt(startDate.clone().startOf('day').utc().valueOf());
    }
    let endDate = this.input('endDate');
    if (endDate) {
      req.endDate = parseInt(endDate.clone().endOf('day').utc().valueOf());
    }
    this.api(action, req, (err, res) => {
      if (res.ok) {
        this.updateItem({ id: item.id, between_paid: action === 'pay' });
      }
    });
  };

  sublogin = (item) => {
    this.emit('login_as_other_user', { id: item.id });
  };

  handleChangeCurrency = () => {
    this.refresh();
  };

  getCurrency = () => {
    return adminModel.getCurrency();
  };
}

const model = new AllStatsDoctorsModel();
export default model;
